import { createSuperclient as _createSuperclient } from './factory';
import { configureContentfulBrowserClient } from './services/contentful-browser';
export const createBrowserSuperclient = (config) => {
    const { contentfulClient, contentfulPreviewClient } = configureContentfulBrowserClient(config);
    return _createSuperclient(config, contentfulClient, contentfulPreviewClient);
};
//# sourceMappingURL=browser.js.map